<template>
  <div class="content">
    <div class="content__row">
      <div class="content__column content__column--wide">
        <h1 class="content__title">Inventario de producto <i v-if="product" v-text="product.title_es"></i></h1>
      </div>
    </div>
    <div class="content__row">
      <item-list :filters="filters"></item-list>
      <item-view :item="item" v-if="itemAction === 'view' && item"></item-view>
      <item-edit @new="newItem" :item="item" v-if="itemAction === 'edit'" :key="key"></item-edit>
      <div class="content__column content__column--small">
        <h1 class="content__title">Opciones</h1>
        <div class="information">
          <h2 class="content__subtitle">Navegación</h2>
          <router-link class="btn btn__action btn--small" :to="{name: 'galleryGroupsView'}">Tipos de descuento</router-link>
          <router-link class="btn btn__action btn--small" :to="{name: 'productView'}">Productos</router-link>
          <h2 class="content__subtitle">Filtros</h2>

          <div class="form__container">
            <label class="form__label form__label--required" for="status_id">Filtrar por estatus</label>
            <div class="form__select-container">
              <select name="status_id" id="status_id" class="form__select" v-model="status_id" @change="setFilters">
                <option :value="null">Cualquiera</option>
                <option v-for="(status, index) in item_status" :key="index" :value="status.id" v-text="status.name"></option>
              </select>
            </div>
          </div>

          <div class="form__container">
            <label class="form__label form__label--required" for="color_id">Filtrar por color</label>
            <div class="form__select-container">
              <select name="color_id" id="color_id" class="form__select" v-model="color_id" @change="setFilters">
                <option :value="null">Todos</option>
                <option v-for="(color, index) in colors" :key="index" :value="color.id" v-text="color.name_es"></option>
              </select>
            </div>
          </div>

          <div class="form__container">
            <label class="form__label form__label--required" for="size_id">Filtrar por tamaño</label>
            <div class="form__select-container">
              <select name="size_id" id="size_id" class="form__select" v-model="size_id" @change="setFilters">
                <option :value="null">Todos</option>
                <option v-for="(size, index) in sizes" :key="index" :value="size.id" v-text="size.name_es"></option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </div>
    <button @click.prevent="newItem" class="btn btn__add">Agregar</button>
  </div>
</template>

<script>
import httpService from '@/core/api/request'
import itemList from './list'
import itemEdit from './edit'
import Mixins from './mixins'
import {item_status} from './mocks'
export default {
  mixins: [
    httpService,
    Mixins
  ],
  components: {
    itemList,
    itemEdit
  },
  data: function () {
    return {
      item_status: item_status,
      key: 0,
      search: null,
      size_id: null,
      color_id: null,
      status_id: null,
      item: null,
      filters: undefined,
      itemAction: null,
      items: null,
      productId: null,
      product: null
    }
  },
  created: function () {
    this.getColors()
    this.getSizes()
    this.productId = this.$route.params.id
    this.getProduct()
  },
  mounted: function () {
    this.$on('view',id => {
      this.getItem(id, 'view')
    })
    this.$on('edit',id => {
      this.getItem(id, 'edit')
    })
  },
  methods: {
    setFilters: function () {
      let filter = ''
      if (this.status_id) {
        filter = filter + '&status_id=eq:' + this.status_id
      }
      if (this.color_id) {
        filter = filter + '&color_id=eq:' + this.color_id
      }
      if (this.size_id) {
        filter = filter + '&size_id=eq:' + this.size_id
      }
      filter = filter.replace(/(^&+|&+$)/, '')
      if (filter.length > 0) {
        this.filters = filter
      } else {
        this.filters = undefined
      }
    },
    getItem: function (id, action) {
      this.itemAction = null
      let httpRequest = {
        params: '',
        module: 'inventory'
      }
      this.getById(id, httpRequest)
        .then(
          item => {
            this.item = item.data
            this.itemAction = action
          }
        )
    },
    getProduct: function () {
      let httpRequest = {
        params: '?fields=title_es',
        module: 'products'
      }
      this.getById(this.productId, httpRequest)
        .then(
          product => {
            this.product = product.data
          }
        )
    },
    newItem: function () {
      this.item = undefined
      this.key = ++this.key
      this.itemAction = 'edit'
    }
  }
}
</script>

<style lang="sass">
  @import "../../assets/sass/components/_home"
  @import "../../assets/sass/components/_forms"
</style>



// WEBPACK FOOTER //
// src/components/inventory/inventory.vue